import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const getCommonResource = async (params) => {
  try {
    const res = await getRequest({ url: "common", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postCommonResource = async (payload) => {
  try {
    const res = await postRequest({ url: "common", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putCommonResource = async ({ id, resource, payload }) => {
  try {
    const res = await putRequest({
      url: "common",
      payload: payload,
      query: { id, resource },
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const trackPageVisit = async (page) => {
  try {
    await postRequest({
      url: "/update-cache",
      headers: { "x-page": page || window?.location?.pathname || "unknown" },
      payload: {},
    });
  } catch (err) {}
};
